import { BaseModal } from '@/components/common';

interface IConfirmationDialog {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm?: () => void;
  title?: string;
  subtitle?: string;
  message?: string;
  okButtonLabel?: string;
  cancelButtonLabel?: string;
}

const ConfirmationDialog = ({
  open,
  onOpenChange,
  onConfirm,
  title,
  subtitle,
  message,
  okButtonLabel,
  cancelButtonLabel,
}: IConfirmationDialog) => {
  return (
    <BaseModal
      open={open}
      onOpen={onOpenChange}
      title={title || 'Confirm this action?'}
      okButtonLabel={okButtonLabel || 'Confirm'}
      okButtonClassName="bg-brand-primary-base"
      onOk={() => {
        onConfirm?.();
        onOpenChange(false);
      }}
      cancelButtonLabel={cancelButtonLabel || 'Cancel'}
      onCancel={() => onOpenChange(false)}
      contentClassName="!w-[560px]"
      subtitle={subtitle && <div className="font-medium text-sm text-neutral-n7">{subtitle}</div>}
    >
      {message && <div className="font-medium text-sm text-neutral-n9">{message}</div>}
    </BaseModal>
  );
};

export default ConfirmationDialog;
